import React from 'react';
import { ChatMessage } from '~/features/chatbot/types/chatbot.types';

interface MessageBubbleProps {
    message: ChatMessage;
}

const MessageBubble = ({ message }: MessageBubbleProps) => {
    const isUser = message.role === 'USER';
    const isRecovery = message.isRecoveryMessage === true;

    if (isRecovery) {
        return (
            <div
                className="display-flex justify-content-start margin-bottom-10"
                data-testid="message-bubble-recovery"
            >
                <div className="alert alert-info max-width-75 margin-bottom-0" role="alert">
                    <span
                        className="rioglyph rioglyph-info-sign margin-right-5"
                        aria-hidden="true"
                    />
                    <span className="text-size-14">
                        {message.content}{' '}
                        <a
                            href="https://slack.com/app_redirect?channel=mdmsupport"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="recovery-slack-link"
                        >
                            #mdmsupport
                        </a>
                    </span>
                </div>
            </div>
        );
    }

    const containerClasses = [
        'display-flex',
        'margin-bottom-10',
        isUser ? 'justify-content-end' : 'justify-content-start',
    ].join(' ');

    const bubbleClasses = [
        'padding-10',
        'padding-left-15',
        'padding-right-15',
        'rounded',
        'max-width-75',
        isUser ? 'bg-highlight' : 'bg-lighter',
        isUser ? 'text-color-white' : 'text-color-darkest',
    ].join(' ');

    return (
        <div className={containerClasses} data-testid={`message-bubble-${message.role === 'USER' ? 'user' : 'assistant'}`}>
            <div className={bubbleClasses}>
                <span className="text-size-14 white-space-pre-wrap">{message.content}</span>
            </div>
        </div>
    );
};

export default MessageBubble;
